module.exports = __webpack_public_path__ + "school/img/videoTrainingBg.a30311d4.jpg";